import { requireAuth } from '@/router/helpers';

const FeRoutes = [
 
];

const AdminRoutes = [
  // categories - first because of precedence of subcat
  {
    path: '/admin/surveys/categories',
    name: 'AdminSurveyCategoriesIndexPage',
    component: () => import('./../pages/categories/admin/Index.vue'),
    beforeEnter: requireAuth,
    meta: { isAdmin: true },
  },
  {
    path: '/admin/surveys/category/create',
    name: 'AdminSurveyCategoriesCreatePage',
    components: {
      default: () => import('./../pages/categories/admin/Index.vue'),
      panel: () => import('./../pages/categories/admin/AddEdit'),
    },
    beforeEnter: requireAuth,
    meta: { isAdmin: true, openPanel: true },
  },
  {
    path: '/admin/surveys/category/:id/edit',
    name: 'AdminSurveyCategoriesEditPage',
    components: {
      default: () => import('./../pages/categories/admin/Index.vue'),
      panel: () => import('./../pages/categories/admin/AddEdit'),
    },
    beforeEnter: requireAuth,
    meta: { isAdmin: true, openPanel: true },
  },
];

export default [...FeRoutes, ...AdminRoutes];
